// extracted by mini-css-extract-plugin
module.exports = {"container":"PanelGroup__container","heading":"PanelGroup__heading"};